import React from "react";
import { motion } from "framer-motion";
import { TopographicBackground, GoldOrb } from "./TopographicBackground";

export const LoadingContour = ({ label = "Preparing the pages", testId = "reader-loading" }) => {
  return (
    <div
      data-testid={testId}
      className="relative flex h-full w-full flex-col items-center justify-center overflow-hidden"
    >
      <GoldOrb className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" size={360} testId="loading-orb" />
      <TopographicBackground
        className="absolute inset-0 h-full w-full"
        opacity={0.6}
        animate
      />
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 flex flex-col items-center gap-5"
      >
        <div className="relative h-9 w-9">
          <span className="absolute inset-0 rounded-full border border-gold/30" />
          <motion.span
            className="absolute inset-0 rounded-full border-t border-gold"
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 2.4, ease: "linear" }}
          />
        </div>
        <p className="kicker text-ink-soft">{label}</p>
      </motion.div>
    </div>
  );
};
